module.exports = __webpack_public_path__ + "img/question-remove-all.e196280a.svg";